import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carlos Martínez',
    business: 'Barbería',
    text: 'Desde que tenemos la web los clientes pueden reservar fácilmente y recibimos más consultas.'
  }, {
    name: 'Laura Gómez',
    business: 'Estética',
    text: 'La nueva web transmite mucha más profesionalidad y confianza.'
  }, {
    name: 'Javier López',
    business: 'Entrenador personal',
    text: 'Antes no teníamos web y ahora los clientes nos encuentran mucho más fácil.'
  }];
  return <section className="py-20 bg-light" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <motion.h2 className="text-3xl md:text-4xl font-bold text-text" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-178">
            Negocios que mejoraron su presencia online
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-179">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-180">
              <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-gray-100" data-id="element-181" />
              <div className="flex gap-1 mb-6" data-id="element-182">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-183" />)}
              </div>
              <p className="text-gray-700 text-lg mb-6 relative z-10 italic" data-id="element-184">
                "{testimonial.text}"
              </p>
              <div className="font-semibold text-text" data-id="element-185">{testimonial.name}</div>
              <div className="text-sm text-gray-400" data-id="element-186">
                {testimonial.business}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}